module.exports = __webpack_public_path__ + "img/13.4a3f0779.png";